import React from 'react';
import { getNumberWithCommas, Kformat } from '../utilities/money';

export default function Stats({ data }) {
  if (data) {
    return (
      <div className="stat_labels">
        <div style={{ flexBasis: '20%' }}>
          24 Hours &nbsp;
          {data?.user_total_balance_a_day_ago?.percentage_change ? (
            <div>
              <span className="stat_value">
                ${Kformat(data?.user_total_balance_a_day_ago?.current_value)}
              </span>
              <span
                className={
                  data?.user_total_balance_a_day_ago?.amount_change > 0
                    ? 'stat_change_pos'
                    : 'stat_change_neg'
                }
              >
                &nbsp;({getNumberWithCommas(data?.user_total_balance_a_day_ago?.percentage_change)}
                %)
              </span>
            </div>
          ) : (
            <div>
              <span className="stat_change">--</span>
            </div>
          )}
        </div>

        <div style={{ flexBasis: '20%' }}>
          Week &nbsp;
          {data?.user_total_balance_a_week_ago?.percentage_change ? (
            <div>
              <span className="stat_value">
                ${Kformat(data?.user_total_balance_a_week_ago?.current_value)}
              </span>
              <span
                className={
                  data?.user_total_balance_a_week_ago?.amount_change > 0
                    ? 'stat_change_pos'
                    : 'stat_change_neg'
                }
              >
                &nbsp;({getNumberWithCommas(data?.user_total_balance_a_week_ago?.percentage_change)}
                %)
              </span>
            </div>
          ) : (
            <div>
              <span className="stat_change">--</span>
            </div>
          )}
        </div>

        <div style={{ flexBasis: '25%' }}>
          Month &nbsp;
          {data?.user_total_balance_a_month_ago?.percentage_change ? (
            <div>
              <span className="stat_value">
                ${Kformat(data?.user_total_balance_a_month_ago?.current_value)}
              </span>
              <span
                className={
                  data?.user_total_balance_a_month_ago?.amount_change > 0
                    ? 'stat_change_pos'
                    : 'stat_change_neg'
                }
              >
                &nbsp;(
                {getNumberWithCommas(data?.user_total_balance_a_month_ago?.percentage_change)}%)
              </span>
            </div>
          ) : (
            <div>
              <span className="stat_change">--</span>
            </div>
          )}
        </div>

        <div style={{ flexBasis: '20%' }}>
          YTD &nbsp;
          {data?.user_total_balance_a_year_ago?.percentage_change ? (
            <div>
              <span className="stat_value">
                ${Kformat(data?.user_total_balance_a_year_ago?.current_value)}
              </span>
              <span
                className={
                  data?.user_total_balance_a_year_ago?.amount_change > 0
                    ? 'stat_change_pos'
                    : 'stat_change_neg'
                }
              >
                &nbsp;({getNumberWithCommas(data?.user_total_balance_a_year_ago?.percentage_change)}
                %)
              </span>
            </div>
          ) : (
            <div>
              <span className="stat_change">--</span>
            </div>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div className="stat_labels">
        <div style={{ flexBasis: '10%' }}>24 Hours</div>
        <div style={{ flexBasis: '20%' }}>
          <span className="stat_value">1--</span>
        </div>

        <div style={{ flexBasis: '20%' }}>
          Week &nbsp; <span className="stat_value">2--</span>{' '}
        </div>

        <div style={{ flexBasis: '25%' }}>
          Month &nbsp; <span className="stat_value">3--</span>{' '}
        </div>

        <div style={{ flexBasis: '20%' }}>
          YTD &nbsp; <span className="stat_value">--</span>{' '}
        </div>
      </div>
    );
  }
}
